"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
/* eslint-disable no-console -- We need to log to console */

class LogoutExecutor {
  constructor() {
    (0, _defineProperty2.default)(this, "LOGOUT_DATA_SELECTOR", '.js-logout-data');
    (0, _defineProperty2.default)(this, "URL_ESHOP_ATTR", 'data-url-eshoplogout');
    (0, _defineProperty2.default)(this, "MAX_ESHOP_TIMEOUT", 5000);
    (0, _defineProperty2.default)(this, "URL_LOGOUT_ATTR", 'data-url-logout');
    (0, _defineProperty2.default)(this, "URL_LOGOUT_DEFAULT", '/system/UI/LogoutPopup/Logout');
    (0, _defineProperty2.default)(this, "AUTH_TOKEN_STORAGE_KEY", 'AuthToken');
    (0, _defineProperty2.default)(this, "ININCHAT_ID_STORAGE_KEY", 'ininChatId');
    (0, _defineProperty2.default)(this, "storage", void 0);
    this.storage = window.sessionStorage;
  }
  doLogout() {
    this.clearSessionStorage();
    this.logoutInInChat();
    this.logoutFromEshop();
  }
  clearSessionStorage() {
    const {
      ori
    } = window;
    if (!ori) {
      console.warn(`[LogoutExecutor.clearSessionStorage] ori namespace not found on window!`);
      return;
    }
    if (ori.webApi) {
      const keys = ori.webApi.getStorageKeys();
      keys.forEach(item => {
        sessionStorage.removeItem(item);
      });
    }
    if (ori.globalApi) {
      // clear globalAPI module
      ori.globalApi.clearStorageItems();
    }
    if (ori.personalMenu) {
      ori.personalMenu.clearStorageItems();
    }
    if (ori.allReportsPage) {
      ori.allReportsPage.clearStorageItems();
    }
    if (this.storage.getItem(this.AUTH_TOKEN_STORAGE_KEY)) {
      this.storage.removeItem(this.AUTH_TOKEN_STORAGE_KEY);
    }
  }
  logoutInInChat() {
    const {
      ori
    } = window;
    if (!ori) {
      console.warn(`[LogoutExecutor.logoutInInChat] ori namespace not found on window!`);
      return;
    }
    const ininChatStorage = this.storage.getItem(this.ININCHAT_ID_STORAGE_KEY);
    if (ori.ininChat && ininChatStorage) {
      console.debug(`[LogoutExecutor.logoutInInChat] Closing InInChat...`);
      ori.ininChat.handleClose();
    }
  }
  logoutFromEshop() {
    const logoutDataElement = document.querySelector(this.LOGOUT_DATA_SELECTOR);
    if (!logoutDataElement) {
      const errorMessage = `[LogoutExecutor.logoutFromEshop] Element ${this.LOGOUT_DATA_SELECTOR} was not found.`;
      console.error(errorMessage);
      throw new Error(errorMessage);
    }
    const urlLogout = logoutDataElement.getAttribute(this.URL_LOGOUT_ATTR) ?? this.URL_LOGOUT_DEFAULT;
    console.debug(`[LogoutExecutor.logoutFromEshop] Logging out using: ${urlLogout}`);
    const urlEshopLogout = logoutDataElement.getAttribute(this.URL_ESHOP_ATTR) ?? '';
    console.debug(`[LogoutExecutor.logoutFromEshop] Logging out from eshop using: ${urlEshopLogout}`);
    if (!urlEshopLogout) {
      console.info(`[LogoutExecutor.logoutFromEshop] Eshop url not found, redirecting to: ${urlLogout}`);
      // eslint-disable-next-line no-restricted-globals -- The user needs to be redirected to the logout url
      location.href = urlLogout;
    }
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      console.info(`[LogoutExecutor.logoutFromEshop] Eshop logout timed out`);
      controller.abort();
    }, this.MAX_ESHOP_TIMEOUT);
    fetch(urlEshopLogout, {
      mode: 'no-cors',
      credentials: 'include',
      signal: controller.signal
    }).catch(error => {
      console.error('[LogoutExecutor.logoutFromEshop] Error while logging out from eshop. ', {
        url: urlEshopLogout,
        error
      });
    }).finally(() => {
      clearTimeout(timeoutId);
      console.info(`[LogoutExecutor.logoutFromEshop] Logged out, redirecting to: ${urlLogout}`);
      // eslint-disable-next-line no-restricted-globals -- The user needs to be redirected to the logout url
      location.href = urlLogout;
    });
  }
}
exports.default = LogoutExecutor;
